import { render, staticRenderFns } from "./ReportPrintArticles.vue?vue&type=template&id=2ba63934&scoped=true&"
import script from "./ReportPrintArticles.vue?vue&type=script&lang=js&"
export * from "./ReportPrintArticles.vue?vue&type=script&lang=js&"
import style0 from "./ReportPrintArticles.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReportPrintArticles.vue?vue&type=style&index=1&id=2ba63934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba63934",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
